import { HttpService } from "../shared/http.service";

export class HeaderService {
  $http = new HttpService();

  constructor() { }

  async findHeader() {
    return this.$http.get("api/header?populate=*");
  }
}